import React from "react";
import "./styles.css";

const Footer = () => {
  return (
    <footer>Need Help? Call 877.883.4575</footer>
  );
};

export default Footer;